// extracted by css-extract-rspack-plugin
export default {"default":"default-NUu7_U","badge":"badge-kUH973"};